import { useCallback, useEffect, useState } from 'react';
import { useChallenge } from 'src/hook/data/useChallenge';
import { useLearn } from 'src/hook/data/useLearn';
import { useAudio } from 'src/hook/global/useAudio';
import { Challenge } from 'src/model/Challenge';
import { ChallengeTypes } from 'src/model/enum/dataEnums';
import { Word } from 'src/model/Word';
import GivenAudioPickDefinition from './ChallengeTypes/GivenAudioPickDefinition/GivenAudioPickDefinition';
import GivenAudioPickSpelling from './ChallengeTypes/GivenAudioPickSpelling/GivenAudioPickSpelling';
import GivenBlankExampleConfirm from './ChallengeTypes/GivenBlankExampleConfirm/GivenBlankExampleConfirm';
import GivenDefinitionPickSpelling from './ChallengeTypes/GivenDefinitionPickSpelling/GivenDefinitionPickSpelling';
import GivenDefinitionPickWord from './ChallengeTypes/GivenDefinitionPickWord/GivenDefinitionPickWord';
import GivenExampleConfirmRemembering from './ChallengeTypes/GivenExampleConfirmRemembering/GivenExampleConfirmRemembering';
import GivenWordPickDefinition from './ChallengeTypes/GivenWordPickDefinition/GivenWordPickDefinition';
import WellDone from './WellDone/WellDone';

interface RenderChallengeProps {
    currentChallenge?: Challenge;
    correctWord?: Word;
    shuffledChoices: { isCorrect: boolean; text: string; wordId: number }[];
    onAnswer: (isCorrect: boolean) => void;
    showFinish: boolean;
}

const RenderChallenge = ({
    currentChallenge,
    correctWord,
    shuffledChoices,
    onAnswer,
    showFinish
}: RenderChallengeProps) => {
    const [isPlaying, setIsPlaying] = useState(false);
    const { playWord } = useAudio();
    const { autoPlay, setAutoPlay } = useChallenge();
    const { currentCard } = useLearn();

    const handlePlayAudio = useCallback((checkAutoPronounce: boolean) => {
        setIsPlaying(true);
        playWord(correctWord?.ID!, checkAutoPronounce);
        setTimeout(() => setIsPlaying(false), 500);
    }, [playWord, correctWord]);



    useEffect(() => {
        // const play = currentChallenge?.Nature ===
        //     ChallengeTypes.GivenWordPickDefinition ||
        //     currentChallenge?.Nature ===
        //     ChallengeTypes.GivenAudioPickDefinition ||
        //     currentChallenge?.Nature ===
        //     ChallengeTypes.GivenAudioPickSpelling;

        if (autoPlay && correctWord?.ID) {
            handlePlayAudio(true);
            setAutoPlay(false);
        }
    }, [autoPlay, correctWord?.ID,
        handlePlayAudio, currentChallenge?.Nature, setAutoPlay, currentCard?.wordId]);



    if (showFinish) return <WellDone />;
    if (!currentChallenge || !correctWord) return null;

    switch (currentChallenge.Nature) {
        case ChallengeTypes.GivenExampleConfirmRemembering:
            return <GivenExampleConfirmRemembering
                correctWord={correctWord}
                shuffledChoices={shuffledChoices}
                onAnswer={onAnswer}
                challenge={currentChallenge}
            />;
        case ChallengeTypes.GivenWordPickDefinition:
            return <GivenWordPickDefinition
                correctWord={correctWord}
                shuffledChoices={shuffledChoices}
                onAnswer={onAnswer}
                handlePlayAudio={handlePlayAudio}
                isPlaying={isPlaying}
            />;
        case ChallengeTypes.GivenDefinitionPickWord:
            return <GivenDefinitionPickWord
                correctWord={correctWord}
                shuffledChoices={shuffledChoices}
                onAnswer={onAnswer}
                challenge={currentChallenge}
            />;
        case ChallengeTypes.GivenBlankExampleConfirm:
            return <GivenBlankExampleConfirm
                correctWord={correctWord}
                shuffledChoices={shuffledChoices}
                onAnswer={onAnswer}
                challenge={currentChallenge}
            />;
        case ChallengeTypes.GivenAudioPickDefinition:
            return <GivenAudioPickDefinition
                correctWord={correctWord}
                shuffledChoices={shuffledChoices}
                onAnswer={onAnswer}
                handlePlayAudio={handlePlayAudio}
                isPlaying={isPlaying}
            />;
        case ChallengeTypes.GivenAudioPickSpelling:
            return <GivenAudioPickSpelling
                correctWord={correctWord}
                shuffledChoices={shuffledChoices}
                onAnswer={onAnswer}
                handlePlayAudio={handlePlayAudio}
                isPlaying={isPlaying}
            />;
        case ChallengeTypes.GivenDefinitionPickSpelling:
            return <GivenDefinitionPickSpelling
                correctWord={correctWord}
                shuffledChoices={shuffledChoices}
                onAnswer={onAnswer}
                challenge={currentChallenge}
            />;
        default:
            return null;
    }
};

export default RenderChallenge;
